@if (type === ItemType.HISTORICOASOCIADO) {
  <div class="card entity-card entity-card--historico">
    <p class="entity-card__title h5 m-0">{{item.ejercicio}}</p>
    @if (item.historico) {
      @for (historicoItem of item.historico; track $index) {
        <div class="history-line">
          <strong>{{historicoItem.cargo}}</strong>
          <span>{{historicoItem.nombreAsociacion | titlecase}}</span>
        </div>
      }
    } @else {
      <div class="history-line">
        <strong>{{item.cargo}}</strong>
        <span>{{item.nombreAsociacion | titlecase}}</span>
      </div>
      <button type="button" class="btn btn-outline-danger btn-sm align-self-start" (click)="deleteItem.emit(item)">
        <i class="bi bi-trash-fill" aria-hidden="true"></i>Eliminar
      </button>
    }
  </div>
} @else {
  <div class="card entity-card entity-card--link" role="link" tabindex="0"
    (click)="goTo()" (keydown.enter)="goTo()" (keydown.space)="$event.preventDefault(); goTo()">
    @if (!notShowImg.includes(type) && soloIdentidad) {
      @if (tieneFoto(item.img) && !fotoRota) {
        <img [src]="filesBasePath + item.img" class="entity-card__photo" [alt]="'Foto de ' + (item.nombre || '')" (error)="fotoRota = true" loading="lazy" width="64" height="64">
      } @else if (!item.ejercicio) {
        <img src="assets/img/default.png" class="entity-card__photo" alt="Sin foto" width="64" height="64">
      }
    }
    <div class="entity-card__body">
      @if (item.nombre && item.apellidos) {
        <p class="entity-card__title">{{ item.nombre | titlecase }}</p>
        <p class="entity-card__sub">{{ item.apellidos | titlecase }}</p>
      } @else if (item.nombre) {
        <p class="entity-card__title">{{ item.nombre | titlecase}}</p>
      } @else if (item.ejercicio && type === ItemType.EJERCICIOS) {
        <p class="entity-card__title">Ejercicio {{ item.ejercicio }}@if (item.esVigente) { <span class="badge text-bg-primary ms-2" data-testid="ejercicio-vigente">Vigente</span> }</p>
      }
      @if (item.id && !soloIdentidad) {
        <p class="entity-card__sub">ID: {{ item.id }}</p>
      }
    </div>
    <i class="bi bi-chevron-right entity-card__chev" aria-hidden="true"></i>
  </div>
}
